// Static campaign content. Edit as needed.
export const CANDIDATE = {
  name: "Robert Richard-Snipes",
  shortName: "Rob",
  office: "NH State Representative",
  district: "Hillsborough District 40",
  wards: "Manchester Wards 1, 3, 10, 11 & 12",
  town: "Manchester, New Hampshire",
  slogan: "ROB4MANCH",
  tagline: "Strong Communities. Secure Future. Bold Solutions.",
  taglineParts: ["Strong Communities.", "Secure Future.", "Bold Solutions."],
  subTagline:
    "A community mobilizer running to bring grassroots voices into the Granite State legislature.",
  email: "rob4nh@gmail.com",
  actblueUrl: "https://secure.actblue.com/donate/snipes4thepeople",
  logoFull:
    "/img/logo-full.png",
  logoBadge:
    "/img/logo-badge.png",
  logoWards:
    "/img/logo-wards.png",
  portrait:
    "/img/portrait-statehouse.png",
  portraitStudio:
    "/img/portrait-studio.jpg",
  portraitClose:
    "/img/portrait-close.jpg",
  bannerWide:
    "/img/banner-wide.jpg",
  committee: "Snipes4ThePeople",
  treasurer: "Sandra Richard",
  treasurerAddress: "6 Mulsey St, Manchester, NH 03101",
  disclaimer:
    "Paid for by Snipes4ThePeople, Sandra Richard — Treasurer, 6 Mulsey St, Manchester, NH 03101",
};

// Manchester Hillsborough 40 ward polling locations.
export const VOTING_WARDS = [
  {
    ward: "1",
    name: "Webster School Auditorium",
    address: "2519 Elm Street, Manchester, NH",
    note: null,
    mapQuery: "Webster School Manchester NH 2519 Elm Street",
  },
  {
    ward: "3",
    name: "Carol M. Rines Center",
    address: "1528 Elm Street, Manchester, NH",
    note: "Use the rear entrance — not the Elm Street entrance.",
    mapQuery: "Carol M Rines Center 1528 Elm Street Manchester NH",
  },
  {
    ward: "10",
    name: "Parker-Varney School",
    address: "223 James Pollock Drive, Manchester, NH",
    note: null,
    mapQuery: "Parker-Varney School Manchester NH 223 James Pollock Drive",
  },
  {
    ward: "11",
    name: "Gossler School",
    address: "145 Parkside Avenue, Manchester, NH",
    note: null,
    mapQuery: "Gossler Park School Manchester NH 145 Parkside Avenue",
  },
  {
    ward: "12",
    name: "Northwest Elementary School",
    address: "300 Youville Street, Manchester, NH",
    note: null,
    mapQuery: "Northwest Elementary School Manchester NH 300 Youville Street",
  },
];

export const ELECTION_DATES = [
  {
    date: "2026-09-08",
    title: "New Hampshire State Primary",
    detail: "Democratic and Republican primary ballots. You must be registered with a party (or Undeclared voters can pick a party ballot on the day) to vote in the primary.",
  },
  {
    date: "2026-11-03",
    title: "General Election",
    detail: "All registered voters may participate. Polls open 6:00 AM – 7:00 PM.",
  },
];

// The Hillsborough 40 floterial slate — Rob plus his three running mates.
// Order: alphabetical by last name.
export const SLATE = [
  {
    id: "erin-kerwin",
    name: "Rep. Erin Kerwin",
    shortName: "Erin Kerwin",
    role: "Incumbent · Former social worker & educator",
    ward: "Manchester, Ward 1",
    bio: "Elected to the NH House in 2024 alongside her running mates. Erin is a former social worker and schoolteacher who fights for quality jobs, strong public schools, and accessible healthcare for Manchester families.",
    photo:
      "/img/slate-kerwin.png",
    initials: "EK",
    links: [
      { label: "Facebook", href: "https://www.facebook.com/profile.php?id=61578471770733" },
      { label: "Ballotpedia", href: "https://ballotpedia.org/Erin_Kerwin" },
    ],
  },
  {
    id: "mark-mackenzie",
    name: "Rep. Mark S. MacKenzie",
    shortName: "Mark MacKenzie",
    role: "Incumbent · Retired Manchester Fire Captain",
    ward: "Manchester, Ward 10",
    bio: "President Emeritus of the NH AFL-CIO and a retired Captain of the Manchester Fire Department. Serving Hillsborough 40 in the NH House since 2022 (and previously 2016–2018), Mark is a lifelong labor and public-safety advocate.",
    photo:
      "/img/slate-mackenzie.png",
    initials: "MM",
    links: [
      { label: "Ballotpedia", href: "https://ballotpedia.org/Mark_MacKenzie" },
    ],
  },
  {
    id: "rob-richard-snipes",
    name: "Robert Richard-Snipes",
    shortName: "Rob Richard-Snipes",
    role: "Community mobilizer · Candidate",
    ward: "Manchester, Ward 3",
    bio: "Career nonprofit worker and community mobilizer. Board chair of Black Lives Matter New Hampshire, and a board member of SOS Recovery Community Organization and Building Community in New Hampshire. He\u2019s seen firsthand how public dollars can actually reach real lives — and he\u2019s running to bring that lived experience to Concord.",
    photo:
      "/img/portrait-statehouse.png",
    initials: "RS",
    links: [
      { label: "About Rob", href: "/about", internal: true },
      { label: "Facebook", href: "https://www.facebook.com/Rob4NH" },
      { label: "Instagram", href: "https://www.instagram.com/rob4nh" },
      { label: "Ballotpedia", href: "https://ballotpedia.org/Robert_Richard-Snipes" },
    ],
    newGuy: true,
  },
  {
    id: "trinidad-tellez",
    name: "Trinidad \u201cDr. Trini\u201d Tellez",
    shortName: "Dr. Trini Tellez",
    role: "Incumbent · Physician & public-health leader",
    ward: "Manchester, Ward 3",
    bio: "A physician and public-health advocate who has served Hillsborough 40 in the NH House since 2022. Dr. Trini has spent her career fighting for health equity and access for New Hampshire's diverse communities.",
    photo:
      "/img/slate-tellez.jpg",
    initials: "TT",
    links: [
      { label: "Facebook", href: "https://www.facebook.com/DoctorTrini4NH" },
      { label: "Ballotpedia", href: "https://ballotpedia.org/Trinidad_Tellez" },
      { label: "Citizens Count", href: "https://www.citizenscount.org/candidate/trinidad-tellez" },
    ],
  },
];

export const ISSUES = [
  {
    title: "Housing You Can Afford",
    summary:
      "Manchester deserves housing policy written by the people who live here — not absentee landlords. Expand starter homes, tenant protections, access to capital for ADUs and innovative housing solutions, and zoning that welcomes families.",
    pillar: "Housing",
  },
  {
    title: "Public Schools, Public Dollars",
    summary:
      "Fully fund NH public schools, end the diversion of taxpayer money to private vouchers, and pay our educators what they're worth.",
    pillar: "Education",
  },
  {
    title: "Healthcare as a Right",
    summary:
      "Expand Medicaid access and lower prescription costs for working families, and protect reproductive freedom. Recovery is a community effort — fund peer-support services, harm-reduction, and treatment access, and end the stigma that keeps neighbors from asking for help.",
    pillar: "Healthcare",
  },
  {
    title: "Workers and Wages",
    summary:
      "A $15+ minimum wage, paid family leave, and the right to organize — Granite Staters work hard and deserve to share in the prosperity they build.",
    pillar: "Labor",
  },
  {
    title: "Civil Rights and Equity",
    summary:
      "Carry forward the community-centered and guided work of Black Lives Matter New Hampshire: police accountability, anti-discrimination protections, and a justice and carceral system that lives up to its name and protects its citizens.",
    pillar: "Justice",
  },
  {
    title: "Climate and the Granite State",
    summary:
      "Protect our forests, rivers, and air. Invest in clean energy jobs and weatherize NH homes to cut bills and emissions together.",
    pillar: "Climate",
  },
];

export const EVENTS = [
  {
    date: "2026-01-18",
    time: "10:00 AM",
    title: "Coffee with Rob — West Manchester",
    location: "Bookery, 844 Elm St, Manchester",
    description:
      "Drop in, grab a cup, and tell me what's on your mind. No agenda — just neighbors.",
  },
  {
    date: "2026-02-04",
    time: "6:30 PM",
    title: "Hillsborough 40 Town Hall",
    location: "Manchester Public Library, Carpenter Auditorium",
    description:
      "An open town hall on housing, schools, and the upcoming legislative session. Q&A welcome.",
  },
  {
    date: "2026-02-22",
    time: "1:00 PM",
    title: "Canvass Launch — Ward 4",
    location: "Veterans Memorial Park",
    description:
      "Kick off the door-knocking season with the team. Snacks, signs, and good company provided.",
  },
  {
    date: "2026-03-15",
    time: "5:00 PM",
    title: "Community Organizing 101 Workshop",
    location: "BLM NH Community Space",
    description:
      "A free skill-share for first-time organizers. Open to anyone who wants to build power in their block.",
  },
];

export const NEWS = [
  {
    date: "2026-07-15",
    tag: "Get Involved",
    title: "Yard Signs & Fundraising — Sign Up Now",
    excerpt:
      "Want a Rob4NH sign in your yard, or looking to help fundraise for the campaign? Fill out this quick form and the team will follow up.",
    sourceUrl: "https://docs.google.com/forms/d/e/1FAIpQLSdlGnn-IpPPgHyQyqF2NiPKzgrPlCUIz6dhwSGQSwvK108FLA/viewform",
    sourceLabel: "Open the sign-up form",
    body: [
      "The best way to help this campaign win is at the neighborhood level — literally. Yard signs signal that Manchester is with us, and every dollar raised goes directly to doors knocked and voters reached.",
      "If you'd like to host a sign or help with fundraising outreach, please fill out the campaign's short intake form. A team member will follow up within 48 hours.",
    ],
  },
  {
    date: "2026-06-17",
    tag: "Op-Ed · Manchester Ink Link",
    title: "The Soapbox: When the Strong Ones Struggle",
    excerpt:
      "Mental health doesn't care about your title, your responsibilities, or how many people depend on you. It can affect anyone.",
    sourceUrl:
      "https://manchester.inklink.news/the-soapbox-when-the-strong-ones-struggle/",
    body: [
      "Lately, I've been struggling.",
      "That's not easy for me to admit.",
      "As someone who has spent years working in mental health, recovery, housing, and community services, I know the statistics. I know the programs. I know the policy solutions. I've sat with people through some of the darkest moments of their lives. I've helped connect people to resources, encouraged them to keep going, and reminded them that they matter.",
      "But lately, I've been the one struggling to believe those things myself.",
      "What I've been reminded of is that mental health does not care whether you are a professional, a leader, a candidate, or the person everyone else turns to for support. Depression, anxiety, grief, loneliness, and burnout do not check your resume before they show up at your door.",
      "And that is exactly why we need to talk about it.",
      "Right now, too many people across New Hampshire are carrying burdens that feel impossible to put down. They are worried about paying rent, affording groceries, finding childcare, caring for aging parents, navigating a health crisis, or simply making it through another day.",
      "Like me.",
      "The hardest part is that many of us have become experts at hiding it. We show up to work. We smile. We attend meetings. We answer the phone. We keep moving forward because people depend on us. From the outside, it looks like we have it all together.",
      "Inside, we are barely holding on.",
      "When we finally find the courage to say, \u201cI'm not okay,\u201d too often the response is silence, a waiting list, a lack of resources, or our pain being minimized because we seem successful, capable, or strong.",
      "The truth is that some of the people who appear the strongest are fighting battles nobody can see.",
      "Mental health is not separate from housing, wages, healthcare, transportation, or community. They are deeply connected. The stress of an unaffordable apartment, an unexpected medical bill, a missed paycheck, or a lack of support does not stay in one corner of our lives. It follows us home. It keeps us awake at night. It shapes our relationships, our health, and our sense of hope.",
      "That is why mental health is not a luxury issue. It is a community issue. It is an economic issue. It is a human issue.",
      "We need leaders who understand that investing in prevention, crisis services, peer support, housing stability, and accessible care is not optional. We need to stop waiting until someone reaches a breaking point before we decide their pain is worth addressing.",
      "Most importantly, we need to stop treating mental health as something that only matters after a tragedy.",
      "This letter is my attempt to avoid one.",
      "I have heard the words \u201cyou're not alone\u201d more times than I can count. They are well-intentioned. But if I am being honest, there have been moments when hearing those words made me feel even more alone. Because knowing others struggle does not automatically make the weight any lighter.",
      "What does help is when people show up. When they check in again. When they listen without trying to fix everything. When they create communities where people can be honest about how they are doing without fear of judgment.",
      "I have always believed that strong communities take care of one another.",
      "That is the New Hampshire I want to help build: a place where people do not have to choose between paying a bill and getting help; where asking for support is seen as an act of courage, not weakness; where help is available before a crisis; and where no one has to suffer in silence because they are afraid nobody will understand.",
      "I am sharing this because I know I am not the only one carrying a heavy burden.",
      "And if this resonates with you, I hope it reminds you of something I am still trying to remember myself:",
      "Your struggle does not make you weak.",
      "Your pain does not make you a burden.",
      "And your life matters more than you know.",
    ],
    resources: [
      { label: "988 Suicide & Crisis Lifeline", value: "Call or text 988", href: "tel:988" },
      { label: "NAMI New Hampshire", value: "naminh.org · 800-242-6264", href: "https://naminh.org" },
      { label: "NH Rapid Response Access Point", value: "1-833-710-6477", href: "tel:18337106477" },
    ],
  },
];

export const ENDORSEMENTS = [
  {
    quote:
      "Rob has been on the frontlines of every fight that matters in Manchester. Concord will be better with him in it.",
    name: "Ronelle Tshiela",
    title: "Co-founder, Black Lives Matter Manchester",
  },
  {
    quote:
      "A serious organizer with a serious plan. He listens first, then he acts — which is exactly what we need.",
    name: "James Owusu",
    title: "Building Community in New Hampshire",
  },
  {
    quote:
      "Rob doesn't just talk about community — he builds it, block by block. That's the kind of leader Hillsborough 40 deserves.",
    name: "Maria Perez",
    title: "Manchester Tenant Union member",
  },
];


export const ABOUT_GALLERY = [
  {
    src: "/img/about-biden.jpg",
    caption: "With President Joe Biden — Making College Affordable panel, Maury High School, Norfolk, VA.",
  },
  {
    src: "/img/chapter1-mural.jpg",
    caption: "Organizing with Manchester community leaders under the ‘We Shall Overcome’ mural.",
  },
  {
    src: "/img/chapter3-rally.jpg",
    caption: "On the line — marching against political violence with Manchester neighbors.",
  },
  {
    src: "/img/about-blm-gala.jpg",
    caption: "BLM New Hampshire Gala — 2024.",
  },
  {
    src: "/img/about-guatape.webp",
    caption: "Off the trail — Guatapé, Colombia.",
  },
  {
    src: "/img/about-filing.webp",
    caption: "Filing day at the NH State House with the Hillsborough 40 slate.",
  },
  {
    src: "/img/about-elf-group.jpeg",
    caption: "Equity Leaders Fellowship — building leaders across the state.",
  },
  {
    src: "/img/about-mom.webp",
    caption: "With Mom — where it all started.",
  },
  {
    src: "/img/about-family.jpeg",
    caption: "Family is the reason.",
  },
];
